module.exports = __webpack_public_path__ + "img/logoEscola2.286a963a.svg";